import { generatePath } from 'react-router-dom';
import { arrayUtils, Nullable } from '@sato/components';
import { trimStart } from 'lodash';

import { ROUTES } from '@routes/routes.constants';
import {
  MainTopicUrlId,
  SubTopicUrlId,
} from '@views/MessagesPage/NewMessagePage/NewMessagePage.types';

export const getRouteWithUrlParams = (
  route: string,
  params: Record<string, string>
) => {
  const urlSearchParams = new URLSearchParams(
    trimStart(window.location.search, '?')
  );

  Object.entries(params).forEach(([key, value]) => {
    urlSearchParams.set(key, value);
  });

  return arrayUtils.joinArrayString([route, urlSearchParams.toString()], '?');
};
export const getMessageTopicRoute = <
  MainTopicT extends MainTopicUrlId,
  SubTopicT extends SubTopicUrlId[MainTopicT],
>({
  topicId,
  subTopicId = null,
}: {
  topicId: MainTopicT;
  subTopicId?: Nullable<SubTopicT>;
}) => generatePath(ROUTES.NEW_MESSAGE_SUB_PAGE, { topicId, subTopicId });
